import { useEffect, useState } from 'react';
import MobileMockup from '../../Assets/StorefrontIcons/MobileMockup.png';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStorefront } from '../../Features/storefrontSlice';
import Mic from '../../Assets/StorefrontIcons/Mic.svg';
import CategorySection from './Components/CategorySection';
import SingleBanner from './Components/SingleBanner';
import CarouselBanner from './Components/CarouselBanner';
import CategoryCollectionList from './Components/CategoryCollectionList';
import CustomCollectionList from './Components/CustomCollectionList';
import OfferDisplay from './Components/OfferDisplay';
import { getPostProfile } from '../../lib/utils/apiCalls';

function Storefront() {
    const dispatch = useDispatch();

    const { storefront } = useSelector((state) => state.storefront.storefront);

    const [userProfile, setUserProfile] = useState({});
    const user = useSelector((state) => state.user.user);

    useEffect(() => {
        const getUserProfile = async () => {
            const profile = await getPostProfile(user.SellerUserId);
            setUserProfile(profile);
        }
    
        setTimeout(() => {
            Object.keys(user).length > 0 && getUserProfile();
        }, 200);
    }, [user]);

    useEffect(() => {
        dispatch(fetchStorefront());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='w-full flex flex-col gap-2 overflow-y-scroll pb-16'>
            <div className="flex items-center justify-between gap-6 m-[20px_19px_24px_20px]">
                <h1 className="text-[#121212] font-bold text-2xl select-none">Storefront</h1>
            </div>

            <div className="flex flex-col gap-6 items-center font-rubik">
                <div className="w-[250px] overflow-hidden relative">
                    <img className='w-full' src={MobileMockup} alt="" />

                    <div className="w-[calc(100%-16px)] h-[calc(100%-12px)] rounded-[30px] overflow-hidden flex flex-col absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-10 bg-[#FFE2E245]">
                        <div className="w-full relative">
                            {
                                storefront?.BackGround ? 
                                <img className='w-full' src={storefront?.BackGround} alt="" /> : 
                                <div className="w-full aspect-video bg-[#868686]"></div>
                            }

                            {
                                storefront?.Logo ? 
                                <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 size-16 rounded-full overflow-hidden">
                                    <img className='size-full' src={storefront?.Logo} alt="" />
                                </div> : 
                                <div className="size-16 -bottom-8 rounded-full overflow-hidden absolute left-1/2 -translate-x-1/2 bg-[#EAEAEA] flex items-center justify-center">
                                    <p className='text-[#1055EB] text-[10px] font-semibold leading-[18px]'>Add Logo</p>
                                </div>
                            }
                        </div>

                        <div className="pt-10 px-2 w-full flex items-center bg-[#FFFFFF]">
                            <div className="w-1/2 py-1 bg-[#F16878] rounded-xl">
                                <p className='text-center text-xs text-[#FFFFFF]'>Store and Deals</p>
                            </div>

                            <div className="w-1/2 py-1">
                                <p className='text-center text-xs text-[#7A869A]'>About us</p>
                            </div>
                        </div>

                        <div className="p-2 w-full">
                            <div className="rounded-xl" 
                                style={{
                                    height: "28px",
                                    background: 'linear-gradient(135deg, #FDB62E80, #F1687880, #748BC580, #0A013080)',
                                }}
                            >
                                <div className="h-[27px] w-full flex items-center gap-2 rounded-xl bg-[#FFFFFF]">
                                    { 
                                        userProfile?.name && 
                                        <p className="w-[calc(100%-70px)] ml-3 font-semibold text-[10px] leading-3 text-[#B0B0B0] line-clamp-1">Search products from {userProfile?.name}</p>
                                    }

                                    <div style={{ backgroundImage: 'linear-gradient(135deg, #FFB42A, #A9D19E, #738CC5, #F17372)', width: '24px', height: '24px' }} className="rounded-full ml-auto mr-[2px] flex items-center justify-center">
                                        <div className="size-2 flex items-center justify-center">
                                            <img className='size-full' src={Mic} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            {storefront?.storeData?.map(item => {
                                if(item.typeData === 'CATEGORY') {
                                    return (
                                        <CategorySection 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.typeData === 'SINGLE_BANNER') {
                                    return (
                                        <SingleBanner 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.typeData === 'CAROUSEL_BANNER') {
                                    return (
                                        <CarouselBanner 
                                            item={item.imageLinkList[0]} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.typeData === 'CATEGORY_COLLECTION_LIST') {
                                    return (
                                        <CategoryCollectionList 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.typeData === 'CUSTOM_COLLECTION_LIST') {
                                    return (
                                        <CustomCollectionList 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                if(item.typeData === 'OFFER_DISPLAY') {
                                    return (
                                        <OfferDisplay 
                                            item={item} 
                                            key={item.id} 
                                        />
                                    )
                                }
                                else return null;
                            })}
                        </div>
                    </div>
                </div>

                <a href='/editStore' target='_blank' rel='noreferrer' className='px-4 py-2 rounded bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText'>Edit Store</a>
            </div>
        </div>
    );
}

export default Storefront;
